import { addMinutes } from 'date-fns'

/**
 * Calcula os horários finais disponíveis para agendamento, a partir dos horários
 * iniciais ocupados/livres da agenda e do horário inicial já escolhido.
 *
 * @param map Horários da agenda, indexados pelo horário inicial de cada slot. **Precisa
 * estar ordenado por chave (horário) crescente**.
 * @param inicial Horário inicial selecionado.
 * @param final Horário do próximo agendamento ocupado, se houver. Horários a partir dele
 * (inclusivo) são excluídos do resultado. Se `undefined`, todos os horários a partir de
 * `inicial` são considerados.
 * @returns Lista ordenada de horários finais possíveis.
 */
export const getItemsHorarioFinal = (
  map: Map<Date, { duracao: number }>,
  inicial: Date,
  final: Date | undefined
): Date[] => {
  const result: Date[] = []
  const inicialNumber = Number(inicial)
  const finalNumber = final ? Number(final) : Infinity

  for (const [horario, { duracao }] of map) {
    const horarioNumber = Number(horario)
    if (horarioNumber < inicialNumber) continue
    if (horarioNumber >= finalNumber) break
    result.push(addMinutes(horario, duracao))
  }
  return result
}
